import { Route, Routes } from 'react-router';

import { CashierSessionPage } from './CashierSessionPage';
import { EntryHelpPage } from './EntryHelpPage';
import { NotFoundPage } from './NotFoundPage';
import { ROUTE_PATHS } from './routePaths';

/*
 * Declarative <Routes>, not createBrowserRouter (ADR-027). The data router costs 16.8 KB gzipped
 * for loaders, actions, and deferred data this app never uses: every fetch is owned by the state
 * machine, not by a route.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTE_PATHS.entry} element={<EntryHelpPage />} />
      <Route path={ROUTE_PATHS.cashier} element={<CashierSessionPage />} />
      <Route path={ROUTE_PATHS.notFound} element={<NotFoundPage />} />
    </Routes>
  );
}
